(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('loadingHttpInterceptor', loadingHttpInterceptor);

    loadingHttpInterceptor.$inject = ['$q', 'loadingPanel'];
    function loadingHttpInterceptor($q, loadingPanel) {
        return {
            request: request,
            requestError: requestError,
            response: response,
            responseError: responseError
        };

        function request(config) {
            loading(true, config);
            return config;
        }

        function requestError(rejection) {
            // loading needs to be true here, so our ref counts are correct.
            loading(true, config);
            return $q.reject(rejection);
        }

        function response(response) {
            loading(false, response);
            return response;
        }

        function responseError(rejection) {
            loading(false, rejection);
            return $q.reject(rejection);
        }

        function loading(show, config) {
            if (config && (config.showLoading || config.config && config.config.showLoading))
                loadingPanel(show);
        }
    }
})();